var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "svg",
    viewBox: "0 0 1440 390",
    xmlns: "http://www.w3.org/2000/svg",
    className: "transition duration-300 ease-in-out delay-150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#303f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#1d3492"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,400 L 0,225 C 109.17857142857142,237.875 218.35714285714283,250.75 331,215 C 443.64285714285717,179.25 559.7500000000001,94.875 698,77 C 836.2499999999999,59.12500000000001 996.6428571428571,107.75 1124,106 C 1251.357142857143,104.25 1345.6785714285716,52.125 1440,0 L 1440,400 L 0,400 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "url(#gradient)",
    fillOpacity: 1,
    className: "transition-all duration-300 ease-in-out delay-150 path-0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactWave);
export default __webpack_public_path__ + "static/media/contactWave.6d2da15e276d124725a480ca0fa2dd55.svg";
export { ForwardRef as ReactComponent };